module.exports = __webpack_public_path__ + "img/yellow-rectangle-table-10.3a3e7205.png";